import { useState } from "react";

import { Button, COLORS, Input } from "abs-ui-components";

import absLogo from "../../../images/abs-logo-white.svg";
import { sendForgotPasswordLink } from "../../../services/signInService";
import { APP_TITLE } from "../../../common/header/constants";

const ForgotPasswordPage = () => {
	const [username, setUsername] = useState("");
	const [error, setError] = useState(null);

	const handleForgotPassword = async () => {
		const forgotPasswordObj = JSON.stringify({ username });
		try {
			const response = await sendForgotPasswordLink(forgotPasswordObj);
		} catch (error) {
			setError(error.message);
			console.error("Error:", error);
		}
	};

	const validateEmail = (email) => {
		const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		return regex.test(email);
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		if (!validateEmail(username)) {
			setError("Please enter a valid email address");
			return;
		}
		setError(null);
		handleForgotPassword();
	};

	return (
		<div class="main-container">
			<div class="row justify-content-center align-items-center vh-100">
				<div class="login-container d-flex justify-content-center align-items-center">
					<div>
						<div class="text-center mt-3">
							<img
								className="abs-logo"
								src={absLogo}
								alt="abs-logo"
							/>
						</div>
						<p className="emmision-text mt-3">
						{ APP_TITLE}
						</p>
						<h4 className="login mt-3"> Forgot Password </h4>
						<form onSubmit={handleSubmit}>
							<div className="input-content mt-3">
								<label htmlFor="username">Username:</label>
								<Input
									type="text"
									id="username"
									value={username}
									onChange={(e) =>
										setUsername(e.target.value)
									}
								/>
							</div>
							{error && (
								<div style={{ color: "red" }}>{error}</div>
							)}
							<Button
								type="submit"
								primaryBackgroundColor={COLORS.RED.DARK}
								primaryColor={COLORS.RED.DARK}
								className="Sign-In mt-5"
							>
								Send an email
							</Button>
						</form>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ForgotPasswordPage;
